import { render } from "./Malam.vue?vue&type=template&id=d1af9d3a"
import script from "./Malam.vue?vue&type=script&lang=js"
export * from "./Malam.vue?vue&type=script&lang=js"
script.render = render

export default script